import el from 'element-ui/src/locale/lang/el';
import { trIdReg } from '@/util/util';
let validatePass = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入译员ID'));
  } else if (value.search(trIdReg) < 0) {
    callback(new Error('译员ID格式有误'));
  } else if (value.length > 32) {
    callback(new Error('译员ID长度超过32个字符'));
  } else {
    callback();
  }
};
export const tableOption = {
  border: true,
  delBtn: false,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: true,
  searchMenuSpan: 6,
  showClomnuBtn: false,
  searchSize: 'mini',
  // menuWidth: 300,
  addBtn: false,
  editBtn: false,
  viewBtn: false,
  selection: false,
  reserveSelection: true,
  props: {
    label: 'label',
    value: 'value',
  },
  column: [
    {
      label: '译员ID',
      labelWidth: 100,
      width: 270,
      prop: 'id',
      row: true,
      search: true,
      editDisabled: true,
      rules: [
        {
          validator: validatePass,
          trigger: 'blur',
        },
      ],
      span: 24,
    },
    {
      label: '译员昵称/姓名',
      labelWidth: 110,
      width: 140,
      prop: 'nickName',
      searchLabelWidth: 1,
      row: true,
      addDisplay: false,
      editDisplay: false,
      search: true,
    },
    {
      label: 'PE权限',
      editDisplay: false,
      prop: 'peStatus',
      value: 1,
      rules: [
        {
          required: true,
          message: '请选择PE权限',
          trigger: 'blur',
        },
      ],
      type: 'switch',
      activeColor: '#ff4949',
      inactiveColor: '#13ce66',
      dicData: [
        {
          label: '启用',
          value: 1,
        },
        {
          label: '禁用',
          value: 2,
        },
      ],
      formslot: true,
    },
    {
      label: '完成轻任务数',
      editDisplay: false,
      type: 'number',
      minRows: 1,
      maxRows: 100,
      row: true,
      span: 24,
      prop: 'finishNum',
    },
    {
      label: '信用分',
      addDisplay: false,
      editDisplay: false,
      row: true,
      prop: 'point',
    },
  ],
};

export const tableOption2 = {
  border: true,
  delBtn: false,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  searchMenuSpan: 6,
  showClomnuBtn: false,
  refreshBtn: false, //刷新按钮
  searchShowBtn: false, //搜索栏目折叠显隐按钮
  header: false, //列显隐
  searchSize: 'mini',
  addBtn: false,
  editBtn: false,
  viewBtn: false,
  selection: true,
  menu: false, // 操作列
  reserveSelection: true,
  column: [
    {
      label: '译员ID',
      labelWidth: 100,
      width: 270,
      prop: 'id',
      row: true,
      search: true,
      editDisabled: true,
      rules: [
        {
          validator: validatePass,
          trigger: 'blur',
        },
      ],
      span: 24,
    },
    {
      label: '译员昵称/姓名',
      searchLabelWidth: 110,
      prop: 'nickName',
      row: true,
      addDisplay: false,
      editDisplay: false,
      search: true,
    },
    {
      label: '打标权限',
      sortable: true,
      prop: 'markingStatus',
      rules: [
        {
          required: true,
          message: '请选择打标权限',
          trigger: 'blur',
        },
      ],
      value: 1,
      dicData: [
        {
          label: '启用',
          value: 1,
        },
        {
          label: '禁用',
          value: 2,
        },
      ],
      editDisplay: false,
      formslot: true,
    },
    {
      label: '打标审核权限',
      sortable: true,
      editDisplay: false,
      rules: [
        {
          required: true,
          message: '请选择打标审核权限',
          trigger: 'blur',
        },
      ],
      value: 1,
      dicData: [
        {
          label: '启用',
          value: 1,
        },
        {
          label: '禁用',
          value: 2,
        },
      ],
      prop: 'markingAuditStatus',
      labelWidth: 110,
      formslot: true,
    },
    {
      label: 'PE权限',
      sortable: true,
      editDisplay: false,
      prop: 'peStatus',
      value: 1,
      rules: [
        {
          required: true,
          message: '请选择PE权限',
          trigger: 'blur',
        },
      ],
      dicData: [
        {
          label: '启用',
          value: 1,
        },
        {
          label: '禁用',
          value: 2,
        },
      ],
      formslot: true,
    },
    {
      label: 'PE审核权限',
      sortable: true,
      labelWidth: 110,
      editDisplay: false,
      rules: [
        {
          required: true,
          message: '请选择PE审核权限',
          trigger: 'blur',
        },
      ],
      prop: 'peAuditStatus',
      value: 1,
      dicData: [
        {
          label: '启用',
          value: 1,
        },
        {
          label: '禁用',
          value: 2,
        },
      ],
      formslot: true,
    },
    {
      label: '完成轻任务数',
      sortable: true,
      editDisplay: false,
      type: 'number',
      minRows: 1,
      maxRows: 100,
      rules: [
        {
          required: true,
          message: '请输入PE信用分',
          trigger: 'blur',
        },
      ],
      row: true,
      span: 24,
      prop: 'finishNum',
    },
    {
      label: '信用分',
      sortable: true,
      addDisplay: false,
      editDisplay: false,
      row: true,
      prop: 'point',
    },
    {
      label: '是否被质控禁用',
      // sortable: true,
      hide: true,
      prop: 'isQcDisabled',
      dicData: [
        {
          label: '是',
          value: true,
        },
        {
          label: '否',
          value: false,
        },
      ],
    },
  ],
};
